// extracted by mini-css-extract-plugin
export default {"Container":"Spinner_Container__0i5X8","Spinner":"Spinner_Spinner__qr707","big":"Spinner_big__G0qYv","spin-fast":"Spinner_spin-fast__Oal98","small":"Spinner_small__WYoHl"};